import _ from 'lodash';

const addFeedback = Symbol('addFeedback');
const notifyObservers = Symbol('notifyObservers');

class FeedbackStore {
  constructor(props) {
    const { globals } = props;
    this.targetedFeedbacks = _.get(globals, ['feedback', 'targeted'], {});
    this.feedbacks = [];
    this.observers = [];
  }

  observe(observer) {
    this.observers.push(observer);
  }

  addError(msg, allowMultiple) {
    this[addFeedback]({ msg, type: 'error' }, allowMultiple);
  }

  addWarn(msg, allowMultiple) {
    this[addFeedback]({ msg, type: 'warn' }, allowMultiple);
  }

  addInfo(msg, allowMultiple) {
    this[addFeedback]({ msg, type: 'info' }, allowMultiple);
  }

  addSuccess(msg, allowMultiple) {
    this[addFeedback]({ msg, type: 'success' }, allowMultiple);
  }

  removeFeedback(feedback) {
    this.feedbacks.splice(this.feedbacks.indexOf(feedback), 1);
    this[notifyObservers]();
  }

  clear() {
    this.feedbacks = [];
    this[notifyObservers]();
  }

  getTargetedFeedback(type, id) {
    const targetedFeedbacksForType = _.get(this.targetedFeedbacks, type, null);
    return targetedFeedbacksForType == null ? null : _.get(targetedFeedbacksForType, id, null);
  }

  [addFeedback] = (feedback, allowMultiple) => {
    if (!allowMultiple) {
      this.feedbacks = [];
    }
    this.feedbacks.push(feedback);
    this[notifyObservers]();
  };

  [notifyObservers] = () => {
    this.observers.forEach(ob => ob.forceUpdate());
  };
}

/**
 * Creates a request-scoped store for feedback on a page.
 * @param props the component props object
 *
 * @returns the feedback store to use for this request.
 */
const getInstance = props => props.getService('feedback', () => new FeedbackStore(props));

export default getInstance;
